<template>
  <div class="bottom" v-if="type === 0">
    <div class="menus" :class="(!showMenu ? 'menuClose' : '') + ' ' + (!showMenuMobile ? 'menuCloseMobile' : '')">
      <div class="logo">iDentSmile</div>
      <div class="menuList">
        <!-- <div class="item" :class="menuTitle == 'Home' ? 'act' : ''" @click="go('/home')">
          <div class="icon">
            <i class="el-icon-monitor"></i>
          </div>
          <span>Home</span>
        </div> -->

        <div class="item" :class="menuTitle == 'Smile Camera' ? 'act' : ''" @click="menuTitle = 'Smile Camera'">
          <div class="icon">
            <i class="el-icon-camera-solid"></i>
          </div>
          <span>Smile Camera</span>
          <i class="el-icon-arrow-up" v-if="menuTitle == 'Smile Camera'"></i>
          <i class="el-icon-arrow-down" v-else></i>
        </div>

        <div class="itemChild" v-show="menuTitle == 'Smile Camera'">
          <div @click="go('/orthodonticSmile')" :class="childTitle == 'Orthodontic Smile' ? 'childAct' : ''">
            <span class="icon"><i class="el-icon-brush"></i></span>
            <a>Orthodontic Smile</a>
          </div>
          <div @click="go('/teethWhitening')" :class="childTitle == 'Teeth Whitening' ? 'childAct' : ''">
            <span class="icon"><i class="el-icon-magic-stick"></i></span>
            <a>Teeth whitening</a>
          </div>
          <!-- <div @click="go('/socialMedia')" :class="childTitle == 'Brightening Smile' ? 'childAct' : ''">
            <span class="icon"><i class="el-icon-magic-stick"></i></span>
            <a>Brightening Smile</a>
          </div>
          <div @click="go('/seo')" :class="childTitle == 'Reputation Report' ? 'childAct' : ''">
            <span class="icon"><i class="el-icon-s-help"></i></span>
            <a>Reputation Report</a>
          </div> -->
        </div>

        <div class="item" :class="menuTitle == 'Case History' ? 'act' : ''" @click="go('/caseHistory')">
          <div class="icon">
            <i class="el-icon-document"></i>
          </div>
          <span>Case History</span>
        </div>

        <div class="item" :class="menuTitle == 'Feedback' ? 'act' : ''" @click="go('/feedback')">
          <div class="icon">
            <i class="el-icon-edit-outline"></i>
          </div>
          <span>Feedback</span>
        </div>

        <div class="item" v-if="accountType == 'super'" :class="menuTitle == 'Setting' ? 'act' : ''" @click="menuTitle = 'Setting'">
          <div class="icon">
            <i class="el-icon-setting"></i>
          </div>
          <span>Setting</span>
          <i class="el-icon-arrow-up" v-if="menuTitle == 'Setting'"></i>
          <i class="el-icon-arrow-down" v-else></i>
        </div>

        <div class="itemChild" v-if="accountType == 'super'" v-show="menuTitle == 'Setting'">
          <div @click="go('/accountManagement')" :class="childTitle == 'Account Management' ? 'childAct' : ''">
            <span class="icon"><i class="el-icon-connection"></i></span>
            <a>Account Management</a>
          </div>
        </div>

        <div class="itemChild" v-if="accountType == 'super'" v-show="menuTitle == 'Setting'">
          <div @click="go('/promotionCode')" :class="childTitle == 'Promotion Code' ? 'childAct' : ''">
            <span class="icon"><i class="el-icon-s-ticket"></i></span>
            <a>Promotion Code</a>
          </div>
        </div>

        <div class="itemChild" v-if="accountType == 'super'" v-show="menuTitle == 'Setting'">
          <div @click="go('/feedbackList')" :class="childTitle == 'Feedback List' ? 'childAct' : ''">
            <span class="icon"><i class="el-icon-document"></i></span>
            <a>Feedback List</a>
          </div>
        </div>

        <div class="itemChild" v-if="accountType == 'super'" v-show="menuTitle == 'Setting'">
          <div @click="go('/setting')" :class="childTitle == 'Setting' ? 'childAct' : ''">
            <span class="icon"><i class="el-icon-setting"></i></span>
            <a>Setting</a>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getActionApi } from '@/network/manageApi'
  export default {
    name: 'PageMenu',
    props:{
      "type":{type:Number,default:0}
    },
    data() {
      return {
        menuTitle: '',
        childTitle: ''
      }
    },
    computed: {
      ...mapGetters(['accountType']),
      ...mapGetters(['showMenu']),
      ...mapGetters(['showMenuMobile']),
    },
    watch: {
      '$route': {
        handler(newRoute) {
          if (!!newRoute.meta) {
            this.menuTitle = newRoute.meta.title
            this.childTitle = newRoute.meta.childTitle
          }
        },
        immediate: true,
      }
    },
    methods: {
      go(url) {
        this.$store.commit('SET_SHOW_MENU_MOBILE', true);
        this.$router.push(url);
      }
    },
  }
</script>

<style scoped>
  .menus{background-color:#ffffff;z-index:100;transition: all 0.1s linear;position: fixed;width:288px;height:100vh;left:0;top:0;display: flex;flex-direction: column;align-items: flex-start;box-shadow: 8px 0 15px -3px rgba(0, 0, 0, 0.1);}
  .menus .logo{height:70px;border-bottom:1px solid #D9D9D9;width: 100%;display: flex;align-items: center;padding:0 20px;font-size: 25px;}
  .menus .menuList{display: flex;flex-direction: column;width: 100%;}
  .menus .menuList .item{height:60px;padding:10px;display: flex;align-items: center;cursor: pointer;}
  .menus .menuList .act{}
  .menus .menuList .act .icon{color:#034844;}
  .menus .menuList .act .icon i{color:#034844;font-weight: bold;}
  .menus .menuList .act span{color:#034844 !important;font-weight: bold;}
  .menus .menuList .item .icon{width: 40px;height:40px;border-radius: 12px;flex-shrink: 0;display: flex;justify-content: center;align-items: center;}
  .menus .menuList .item .icon img{max-width: 24px;max-height: 24px;}
  .menus .menuList .item span{color:#717D96;font-size:14px;margin-left:6px;width: 100%;}
  .menus .menuList .item i{flex-shrink: 0;color:#71839B;font-size:20px;}
  .menus .menuList .item .el-icon-arrow-down{margin-right: 10px;}
  .menus .menuList .itemChild div{display: flex;align-items: center;color: #717D96;font-size: 14px;cursor: pointer;padding-left:10px;height: 40px;}
  .menus .menuList .itemChild a{color: #717D96;}
  .menus .menuList .itemChild div .icon{width: 40px;height: 40px;font-size:18px;display: flex;align-items: center;justify-content: center;margin-right:6px;}
  .childAct{background-color: #E6ECEB;border-right: 4px solid #034844;}
  .childAct .icon{color:#034844;}
  .childAct a{color:#034844 !important;}
  .menuClose{width:90px !important;}
  .menuClose .logo{font-size: 16px !important;}
  .menuClose .menuList span{display: none;}
  .menuClose .menuList .act{background-color: none !important;}
  /* .menuClose .menuList .item i{display: none;} */
  .menuClose .mobile{display: block;}
  .menuClose .menuList .itemChild a{display: none;}
  .menuClose .pc{display: none;}
  .mobile{display: none;}

  @media (max-width: 768px) {
    .menus{position: fixed;top:-100vh;left:0;width: 100vw;}
    .menuCloseMobile{top:0 !important;width: 100vw !important;}
    .menuCloseMobile .menuList span{display: block;}
    .menuCloseMobile .menuList .act{background-color: block !important;}
    .menuCloseMobile .menuList .item i{display: block;}
    .menuCloseMobile .mobile{display: block;}
    .menuCloseMobile .menuList .itemChild a{display: block;}
    .menuCloseMobile .pc{display: block !important;}
    .mobile{display: none !important;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .menus{width:90px;}
    .el-icon-s-operation{display: none !important;}
    .menus .menuList span{display: none;}
    .menus .menuList .act{background-color: none !important;}
    /* .menus .menuList .item i{display: none;} */
    .menus .menuList .itemChild a{display: none;}
    .menus .logo{font-size: 16px !important;}
    .mobile{display: block;}
    .pc{display: none;}
  }
</style>
